// Utility to get the correct Authorization header for API calls
// Usage: getAuthHeader('token') or getAuthHeader('buyerToken')
export function getAuthHeader(tokenType = 'token') {
    const token = localStorage.getItem(tokenType);

    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
}
